import * as React from "react";
import ITitleWidgetProps from "./ITitleWidget";
import "../../../assets/sass/widgets/titleWidget.scss";

/**
 * @class Title
 * @param props
 * @constructor
 * @category Widgets
 * @description widgets used for showing various type of titles used for the components and its sections
 */
const TitleWidget: React.FC<ITitleWidgetProps> = (props) => {
    const { className, schema, id } = props;
    switch (schema.const && schema.const.tag) {
        case "span": {
            return <span className={className}>{schema.title}</span>;
        }
        case "p": {
            return <p className={className}>{schema.title}</p>;
        }
        case "h2":
        case "h2-underline": {
            return (
                <h2 id={id} className={`header-2 ${schema.const.tag.includes("underline") ? "underline" : ""}`}>
                    {schema.title}
                </h2>
            );
        }
        case "h3":
        case "h3-underline": {
            return (
                <h3 id={id} className={`header-3 ${schema.const.tag.includes("underline") ? "underline" : ""}`}>
                    {schema.title}
                </h3>
            );
        }
        case "div": {
            return <div className="">{schema.title}</div>;
        }
        case "legend": {
            return <legend>{schema.const.label}</legend>;
        }
        default:
            return <p className={className}>{schema.title}</p>;
    }
};

export default TitleWidget;
